import { FormInstance } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import FieldNameInHeader from '../../components/fieldNameInHeader';
import useAccessForItem from '../../hooks/useAccessForItem';
import useStatusEditProject from '../../hooks/useStatusEditProject';
import { RootState } from '../../store';
import { TaskBoardTaskAssignee } from '../../taskBoard/component/taskBoardTaskAssignee';
import { ItemType, MappingItemIdIndexType } from '../../types';
import FieldName from '../formField/fieldName';

interface IDrawerPanelLabel {
    form: FormInstance<ItemType>;
}

const DrawerPanelLabel: React.FC<IDrawerPanelLabel> = ({ form }) => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const updatedItem = currentGantItem ? itemsList[mappingItemIdIndex[currentGantItem?.id]] : undefined;

    const isEditableProject = useStatusEditProject(updatedItem?.projectId);

    const access = useAccessForItem(currentGantItem, [
        'work-item.all.edit',
        'work-item.all.manage',
        'work-item.owner.edit',
        'work-item.owner.manage',
        'work-item.assignee.edit',
        'work-item.assignee.manage',
    ]);

    return (
        <FieldNameInHeader<ItemType>
            form={form}
            field={<FieldName />}
            fieldAvatar={<TaskBoardTaskAssignee userId={updatedItem?.ownerItemId} />}
            valueNameField={updatedItem?.name}
            isShowEditButton={isEditableProject && updatedItem?.roleItem === 'workItem' && access}
        />
    );
};

export default DrawerPanelLabel;
